<!-- 流量奖励 [[ -->
<template>
    <div class="profit-con flow-reward">
        <ul class="profit-con-tab">
            <li class="profit-con-label" :class="{'color-theme-active':item}" @click="itemClick()">收益明细</li>
            <li class="profit-con-label" :class="{'color-theme-active':arrival}" @click="arrivalClick">已到账明细</li>
        </ul>

        <!-- 奖励明细 [[ -->
        <div class="profit-tab-con reward-detail" v-show="item">
            <div class="profit-chart-top">
                <p class="profit-time-name f-inlineblock-top">收益时间</p>
                <div class="profit-time-con f-inlineblock-middle">
                    <el-date-picker v-model="searchParams.dateVal" type="daterange" range-separator="至"
                        :start-placeholder="defaultsDate" :end-placeholder="defaulteDate" :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>

            <div class="profit-chart" style="margin-bottom: 30px;">
                <div id="mountNode0"></div>
            </div>

            <div class="profit-list">
                <table class="profit-table">
                    <tr class="profit-table-head bg-gray">
                        <th class="profit-td-1">
                            <p class="profit-td-con">日期</p>
                        </th>
                        <th class="profit-td-2">
                            <p class="profit-td-con">内容标题</p>
                        </th>
                        <th class="profit-td-3 profit-td-border">
                            <p class="profit-td-con">收益金额</p>
                        </th>
                    </tr>
                    <template v-if="profitItemTable.length>0">
                        <tr class="profit-table-tr" v-for="(itemData,index) in profitItemTable" :key="index">
                            <td class="profit-td-1">
                                <p class="profit-td-con">{{itemData.dataTime}}</p>
                            </td>
                            <td class="profit-td-2">
                                <p class="profit-td-con">{{itemData.articleTitle}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">{{itemData.profit}}</p>
                            </td>
                        </tr>
                    </template>
                    <tr class="profit-table-tr" v-else>
                        <td colspan="3" align="center" class="profit-td-1 profit-td-border">
                            <p style="text-align: center;">没数据</p>
                        </td>
                    </tr>
                </table>

                <!-- 分页 -->
                <pagination :total="searchParams.count" :page-size="searchParams.pageSize" @change="itemPageChange($event,1)"
                    ref="pager">
                </pagination>

            </div>
        </div>
        <!-- 奖励明细 ]] -->

        <!-- 到账明细 ]] -->
        <div class="profit-tab-con reward-detail" v-show="arrival">
            <div class="profit-chart-top">
                <p class="profit-time-name f-inlineblock-top">收益时间</p>
                <div class="profit-time-con f-inlineblock-middle">
                    <el-date-picker v-model="dateVal" type="daterange" range-separator="至" :start-placeholder="defaultsDate"
                        :end-placeholder="defaulteDate" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>

            <div class="profit-list">
                <table class="profit-table" style="max-height:316px;overflow: hidden;">
                    <tr class="profit-table-head bg-gray">
                        <th style="width:100px" class="profit-td-1">
                            <p style="width:100px" class="profit-td-con">到账时间</p>
                        </th>
                        <th class="profit-td-2" style="width:300px">
                            <p class="profit-td-con">内容标题</p>
                        </th>
                        <th class="profit-td-3 profit-td-border">
                            <p class="profit-td-con">税后实收</p>
                        </th>
                        <th class="profit-td-3 profit-td-border">
                            <p class="profit-td-con">代缴税费</p>
                        </th>
                    </tr>
                    <template v-if="profitItemTable2.length>0">
                        <tr class="profit-table-tr" v-for="(itemData,index) in profitItemTable2" :key="index">
                            <td style="width:100px" class="profit-td-1">
                                <p style="width:100px" class="profit-td-con">{{itemData.data_time}}</p>
                            </td>
                            <td class="profit-td-2">
                                <p class="profit-td-con">{{itemData.article_title}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">{{itemData.real_amount}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">{{itemData.real_tax}}</p>
                            </td>
                        </tr>
                    </template>
                    <tr class="profit-table-tr" v-else>
                        <td colspan="4" align="center" class="profit-td-border">
                            <p style="text-align: center;">没数据</p>
                        </td>
                    </tr>
                </table>

                <!-- 分页 -->

                <pagination :total="count" :page-size="searchParams.pageSize" @change="itemPageChange($event,2)"
                    ref="pager">
                </pagination>

            </div>
        </div>
        <!-- 到账明细 ]] -->
    </div>
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/profit/profit.scss';
.profit-chart-top .profit-time-name {
    line-height: 35px;
}
</style>
<!-- 流量奖励 ]] -->
<script>
import switchButton from 'Components/v4/button/switch_button';
import pagination from 'Components/v4/pagination/pagination_v4';
import { profitItemList, dailyFlowList, incomeFlowAccount } from 'Services/getData.js';
import G2 from '@antv/g2';
export default {
    data() {
        return {
            detail: false,
            item: true,
            arrival: false,
            searchMonth: true,
            searchDay: true,
            searchParams: {
                beginTime: '',
                endTime: '',
                dateVal: [],
                pageSize: 5,
                pageIndex: 0,
                count: 0,
                type: 1
            },
            dateVal: [],
            count: 0,
            defaultsDate: '',
            defaulteDate: '',
            monthDefaultsDate: '',
            monthDefaulteDate: '',
            profitItemTable: [],
            profitItemTable2: [],
            dailyFlowTable: [],
            dailyFlowParams: {
                beginTime: '',
                endTime: '',
                dateVal: [],
                pageSize: 5,
                pageIndex: 0,
                count: 0,
                type: 1
            },
            chart0: '',
            switchData: [{ name: '日', value: 1 }, { name: '月', value: 2 }],
            switchButVal: 1,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
                }
            }
        }
    },
    components: {
        pagination, switchButton
    },
    mounted() {

        this.getDefaulteDate();
        this.getList();
        this.getDailyFlowList();
    },
    watch: {
        'searchParams.dateVal': function (val) {
            this.getList();
            this.getDailyFlowList();
        },
        'dateVal': function (val) {
            if (val !== null) {
                this.getList2();
            }
        }
    },
    methods: {
        dateChange(val) {
            console.log(this.dailyFlowParams.dateVal)
        },
        getDefaulteDate() {
            this.dateFormat = 'yyyy-MM-dd';
            let startDate = Date.now() - 8.64e7 * 6;
            let endDate = Date.now();

            this.dateVal = [this.$common.formatDate(startDate, '-'), this.$common.formatDate(endDate, '-')];
            this.defaultsDate = this.$common.formatDate(startDate, '-');
            this.defaulteDate = this.$common.formatDate(endDate, '-');
            this.monthDefaultsDate = this.defaultsDate;
            this.monthDefaulteDate = this.defaulteDate;

            // this.dailyFlowParams.dateVal[0] = this.$common.formatDate(startDate,'-');
            // this.dailyFlowParams.dateVal[1] = this.$common.formatDate(endDate,'-');

            this.searchParams.dateVal[0] = this.$common.formatDate(startDate, '-');
            this.searchParams.dateVal[1] = this.$common.formatDate(endDate, '-');
        },
        formatMoney(profit) {
            return Number(profit).toLocaleString('en-US');
        },
        itemPageChange(param, type) {
            this.searchParams.pageSize = param.pageSize; // 发送给接口的字段
            this.searchParams.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            if (type === 1) {
                this.getList();
            }
            if (type === 2) {
                this.getList2();
            }
        },
        itemClick() {
            // this.detail = false;
            this.item = true;
            this.arrival = false;
            this.getList();
            this.getDailyFlowList();
        },
        arrivalClick() {
            this.item = false;
            this.arrival = true;
            this.getList2();
        },
        async getList() {//奖励明细
            this.searchParams.beginTime = this.searchParams.dateVal[0];
            this.searchParams.endTime = this.searchParams.dateVal[1];
            let res = await profitItemList(this.searchParams);
            if (res.data.code == 0) {
                this.profitItemTable = res.data.data.data;
                this.searchParams.count = res.data.data.count;
                this.searchParams.pageSize = res.data.data.size;
            }
        },
        async getList2() {//已到账明细
            this.searchParams.beginTime = this.dateVal[0];
            this.searchParams.endTime = this.dateVal[1];
            let res = await incomeFlowAccount(this.searchParams);
            console.log(res)
            if (res.data.code == 0) {
                this.profitItemTable2 = res.data.data.data;
                this.count = res.data.data.count;
                this.searchParams.pageSize = res.data.data.size;
            }
        },
        async getDailyFlowList(defaultMonth = 0) {//奖励详情
            this.getChartData();
        },
        async getChartData() {//奖励详情绘图
            let params = {};
            params.beginTime = this.searchParams.dateVal[0];
            params.endTime = this.searchParams.dateVal[1];
            params.type = this.searchParams.type;
            let res = await dailyFlowList(params);
            if (res.status === 200 && res.data.code === 0) {
                this.charShow(res.data.data);
            }

        },
        charShow(retData) {
            if (!this.chart0) {
                this.chart0 = new G2.Chart({
                    container: 'mountNode0',
                    forceFit: true,
                    height: 300,
                    width: 600,
                    padding: [20, 50, 45, 50]
                });
            }
            retData.forEach((v, k) => {
                v.profit = Number(v.profit);
            })
            this.chart0.source(retData);
            this.chart0.scale('profit', {
                min: 0,
                alias: "收益"
            });
            this.chart0.scale('dataTime', {
                // range: [0, 1]
            });
            this.chart0.tooltip({
                crosshairs: {
                    type: 'line'
                }
            });
            this.chart0.line().position('dataTime*profit').color('#FD7E28');
            this.chart0.point().position('dataTime*profit').size(4).shape('circle').style({
                stroke: '#FD7E28',
                fill: '#FD7E28',
                lineWidth: 1
            });
            this.chart0.render();
        }
    }
}

</script>